/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ConfigureSlackStepMessages = defineMessages({
  title: {
    id: 'Slack.ConfigureSlackStepMessages.title',
    defaultMessage: 'Configure your Slack bot'
  },
  stepOne: {
    id: 'Slack.ConfigureSlackStepMessages.stepOne',
    defaultMessage:
      'On the Slack app settings page, go to the {eventSubscriptions} tab. Switch the {enableEvents} toggle to the {on} position. In the provided text entry field, paste your request URL.'
  },
  eventSubscriptions: {
    id: 'Slack.ConfigureSlackStepMessages.eventSubscriptions',
    defaultMessage: 'Event Subscriptions'
  },
  enableEvents: {
    id: 'Slack.ConfigureSlackStepMessages.enableEvents',
    defaultMessage: 'Enable Events'
  },
  on: {
    id: 'Slack.ConfigureSlackStepMessages.on',
    defaultMessage: 'On'
  },
  generatedRequestUrlLabel: {
    id: 'Slack.ConfigureSlackStepMessages.generatedRequestUrlLabel',
    defaultMessage: 'Generated request URL'
  },
  note: {
    id: 'Slack.ConfigureSlackStepMessages.note',
    defaultMessage:
      'The generated request URL will be using the latest service API version. <link>Learn more</link>'
  },
  stepTwo: {
    id: 'Slack.ConfigureSlackStepMessages.stepTwo',
    defaultMessage:
      'On the {eventSubscriptions} tab, find the {subscribeToBotEvents} section. Click {addABotUserEvent}, and then select the event types you want to subscribe to. You must select at least one of the following types:'
  },
  subscribeToBotEvents: {
    id: 'Slack.ConfigureSlackStepMessages.subscribeToBotEvents',
    defaultMessage: 'Subscribe to Bot Events'
  },
  addABotUserEvent: {
    id: 'Slack.ConfigureSlackStepMessages.addABotUserEvent',
    defaultMessage: 'Add Bot User Event'
  },
  eventTypeOneName: {
    id: 'Slack.ConfigureSlackStepMessages.eventTypeOneName',
    defaultMessage: 'message.im'
  },
  eventTypeOneDescription: {
    id: 'Slack.ConfigureSlackStepMessages.eventTypeOneDescription',
    defaultMessage:
      '{eventTypeOneName}: Listens for message events that are posted in a direct message channel.'
  },
  eventTypeTwoName: {
    id: 'Slack.ConfigureSlackStepMessages.eventTypeTwoName',
    defaultMessage: 'app_mention'
  },
  eventTypeTwoDescription: {
    id: 'Slack.ConfigureSlackStepMessages.eventTypeTwoDescription',
    defaultMessage:
      '{eventTypeTwoName}: Listens for only message events that mention your app or bot.'
  },
  stepThree: {
    id: 'Slack.ConfigureSlackStepMessages.stepThree',
    defaultMessage: 'Click {saveChanges}.'
  },
  generateCallbackUrl: {
    id: 'Slack.ConfigureSlackStepMessages.generateCallbackUrl',
    defaultMessage: 'Generate callback URL'
  }
});
